import { newTracker, trackStructEvent } from '@snowplow/browser-tracker';

export class Mamka {
  private nameSpace: string;

  private category: string;

  constructor(nameSpace: string, category: string) {
    this.nameSpace = nameSpace;
    this.category = category;

    newTracker(nameSpace, 'avsplow.com', {
      appId: 'tp_widgets',
      encodeBase64: false,
      trackerConfiguration: {
        postPath: '/a/j/',
      },
    });
  }

  send = <T>(action: string, metrics: T) => {
    if (process.env.NODE_ENV === 'production') {
      trackStructEvent(
        {
          category: this.category,
          action,
          property: '',
          value: undefined,
          context: [metrics],
        },
        [this.nameSpace],
      );
    }
  };
}
